import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("iksha_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export default api;
